"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ui = require("./ui");
var uix = require("./uix");
var csx = require("./base/csx");
var appTabsContainer_1 = require("./tabs/v2/appTabsContainer");
var Modal = require('react-modal');
var omniSearch_1 = require("./omniSearch/omniSearch");
var fileTree_1 = require("./fileTree");
var selectListView_1 = require("./selectListView");
var inputDialog_1 = require("./dialogs/inputDialog");
var serverExit_1 = require("./serverExit/serverExit");
var statusBar_1 = require("./statusBar");
var mainPanel_1 = require("./mainPanel");
var findAndReplace_1 = require("./findAndReplace");
/** Force require  */
var gotoHistory = require("./gotoHistory");
var clipboardRing = require("./clipboardRing");
var configCreator = require("./configCreator/configCreator");
var settings = require("./settings/settings");
var openFileFromServerDisk = require("./commands/general/openFileFromServerDisk");
var gitAddAllCommitAndPush = require("./commands/general/gitAddAllCommitAndPush");
var gitFetchLatestAndRebase = require("./commands/general/gitFetchLatestAndRebase");
var ensureImport = gotoHistory
    || configCreator
    || settings
    || openFileFromServerDisk
    || gitAddAllCommitAndPush
    || gitFetchLatestAndRebase
    || clipboardRing;
var Root = /** @class */ (function (_super) {
    __extends(Root, _super);
    function Root(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.refs.leftNav.toggle();
        };
        _this.state = {};
        return _this;
    }
    Root.prototype.componentDidMount = function () {
        uix.setup();
    };
    Root.prototype.render = function () {
        var toret = React.createElement("div", { id: "root", style: csx.vertical },
            React.createElement(omniSearch_1.OmniSearch, null),
            React.createElement(serverExit_1.ServerExit, null),
            React.createElement(selectListView_1.SelectListView, null),
            React.createElement(inputDialog_1.InputDialog, null),
            React.createElement("div", { style: csx.extend(csx.flex, csx.horizontal) },
                React.createElement(fileTree_1.FileTree, null),
                React.createElement(appTabsContainer_1.AppTabsContainer, null)),
            React.createElement(findAndReplace_1.FindAndReplace, null),
            React.createElement(mainPanel_1.MainPanel, null),
            React.createElement(statusBar_1.StatusBar, { ref: "statusBar" }));
        return toret;
    };
    return Root;
}(ui.BaseComponent));
exports.Root = Root;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/root.js
 ** module id = 449
 ** module chunks = 0
 **/